export const sm = {
  msg:
    {
      username: 'Username',
      password: 'Password',
      verification_code: 'Code Fa\'amaonia',
      login: 'TATALA',
      changeLanguage: '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      submit_button_text: 'Submit',
      enter: 'Enter',
      en: 'English',
      ms: 'Bahasa Melayu',
      id: 'Bahasa Indonesia',
      zh: 'Chinese',
      to: 'Tonga',
      sm: 'Samoan',
      fj: 'Fijian',
      copyright: 'Powered by Global Psytech',
      new_password: 'New Password',
      confirm_new_password: 'Confirm New Password',
      forgot_password_header: 'Forgot Password',
      basic_info: 'Basic Information',
      password_set: 'Set Password',
      sign_up_1: 'Tagata fou?&nbsp',
      sign_up_2: 'Kiliki e Fai ai sau Resitala.',
      sign_up_3: '',
      sign_up: 'Fai sau Resitala',
      note: 'Fa\'amatalaga: E tatau ona fai muamua sau resitala e fa\'aaoga ai le code fa\'amaonia e tu\'uina atu a\'o le\'i tatalaina.',
      already_signed_up: 'Ua uma ona fai sau resitala? Ta i totonu lau code fa\'amaonia e tatala ai.',
      product_info: 'Product Applied',
      continue: 'Continue',
      back: 'Back',
      cancel_reset: 'FA\'ALĒAOGĀ',
      forgot_password: 'Forgot Password?',
      sign_up_message: 'to create an account',
      reset_success: 'Successfully reset your password. Please login using the new password.',
      dpa_heading: 'Maliega mo Puipuiga o Fa\'amaumauga Patino',
      dpa_body1: 'Ua fa’atinoina le GFI ina ia tausia ai le teu fa’aliloliloina o fa’amatalaga e tuuina mai e ogatasi ma le Tulafono mo le Puipuia o Fa’amatalaga. Mo le tausisia o tulafono fa’atonutonu e fa’atatau i le puipuiina o fa’amatalaga, o le a matou fa’amautinoaina o fa’amaumauga/fa’amatalaga aoina mai i lenei s’uega o le a tuuina atu na’o le tagata fa’atau lea o loo matou fa’atautaia ai lenei su’ega poo le tagata ua fa’atagaina e fai ma sui filifilia a le tagata fa’atau.',
      dpa_body2: 'O fa’amaumauga/fa’amatalaga uma o le a teuina ma tuuina atu ma le talafeagai ma saogalemū, tusa pe nofo i totonu o Samoa poo fafo le tagata fa’atau.',
      dpa_body3: 'O ni isi fesoota’iga e faia fa’atatau i le fa’aaogaina o fa’amaumauga/fa’amatalaga o le a tuuina i aiaiga ma tulaga a le tagata fa’atau ma lana mataupu.',
      close: 'Tāpuni ʻa',
      reset_button: 'Submit',
      successfully_register: 'Ua taliaina lau lesitala. Fa’amolemole saini i totonu e fa’aaoga ai lou igoa lesitala ma le password.',
      cloned_user: 'Your last GFI score is still valid. Hence, you do not need to retake the GFI assessment.',
      password_changed: 'Please login with your new password.',
      loading_text: 'loading...',
      month_label: 'Months',
      create_registration: 'Resitala ma lau code fa\'amaonia.',
      login_instruction: 'Fa\'atonuga',
      login_instruction_title: 'A\'o le\'i faia le iloiloga, fa\'amolemole ia mautinoa mea nei:',
      login_instruction_1_heading: 'Ta\'iala mo le Faia o le Iloiloga o le GFI',
      login_instruction_1: ' – Faitau ma le fa\'aeteete fa\'atonuga uma a\'o le\'i amata.',
      login_instruction_2_heading: 'Siosiomaga Filemu',
      login_instruction_2: ' – Filifili se nofoaga filemu e le fa\'alavelaveina ai oe.',
      login_instruction_3_heading: 'Taimi Fa\'atulaga',
      login_instruction_3: ' – Fa\'atulaga se taimi e aunoa ma se fa\'alavelave, e fa\'auma ai le iloiloga i le taimi e tasi.',
      user_guide: 'Ta\'iala mo Tagata Uma'
    },
  error: {
    full_name_required: 'Fa’amolemole tusi lou igoa atoa e pei ona tusia ai i luga o lou ID faigaluega.',
    full_name_min: 'O le igoa atoa e tatau ona lē ititi ifo ma le 5 mata’itusi le umi.',
    full_name_max: 'O le igoa atoa e le mafai ona sili atu ma le 80 mata’itusi.',
    full_name_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, avanoa, ma mata’itusi fa’apitoa o loo mulimuli mai: @ ’ – ma le / .',

    first_name_required: 'Fa\'amolemole ta i totonu lou igoa muamua e pei ona iai i luga o lau ID aloa\'ia.',
    first_name_min: 'E tatau ona sili atu ma le 3 mata’itusi le umi o le igoa muamua.',
    first_name_max: 'E le mafai ona sili atu ma le 80 mata’itusi le umi o le igoa muamua.',
    first_name_regex: 'O mata’itusi e taliaina na\'o mata’itusi o le alafapeta, avanoa (space), ma fa\'ailoga fa\'apitoa nei: @ ’ – ma le /.',

    last_name_required: 'Fa\'amolemole ta i totonu lou fa\'ai\'u e pei ona iai i luga o lau ID aloa\'ia.',
    last_name_min: 'E tatau ona sili atu ma le 3 mata’itusi le umi o le fa\'ai\'u.',
    last_name_max: 'E le mafai ona sili atu i le 80 mata’itusi le umi o le fa\'ai\'u.',
    last_name_regex: 'O mata’itusi e taliaina na\'o mata’itusi o le alafapeta, avanoa (space), ma fa\'ailoga fa\'apitoa nei: @ ’ – ma le /.',

    id_num_min: 'The ID number must be at least 1 characters long.',
    id_num_required: 'Fa’amolemole tuu i totonu le numera o lau ID.',
    id_num_max: 'E le tatau ona sili atu ma le 20 mata’itusi poo numera patino ia te oe o lau ID.',
    id_num_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: - ma le /',

    business_reg_required: 'Fa’amolemole tuu i totonu le numera lesitala o le pisinisi a lau kamupani / numera o le laisene o lau pisinisi.',
    business_reg_max: 'E le tatau ona sili atu ma le 20 mata’itusi le numera lesitala o le pisinisi / o le numera o le laisene pisinisi.',
    business_reg_min: 'O le numera lesitala o le pisinisi / o le numera o le laisene pisinisi e tatau ona pe tusa ma le 3 mata’itusi le umi.',
    business_reg_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: - ma le /',

    company_name_required: 'Fa’amolemole tusi le igoa o lau kamupani.',
    company_name_min: 'O le igoa o le kamupani e tatau ona lē  ititi ifo ma le 5 mata’itusi le umi.',
    company_name_max: 'E le tatau ona sili atu ma le 80 mata’itusi le igoa o le kamupani.',
    company_name_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, avanoa, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: . - & () and ’',

    business_category_required: 'Select business category',
    product_applied_required: 'Fa\'amolemole filifili le ituaiga fa\'atupega.',
    commencement_date_required: 'Please enter your company’s business commencement date.',
    facility_required: 'Please select the facilities you are applying',
    facilities_required: 'Please select the facilities you are applying.',

    amount_applied_regex: 'The only acceptable characters are numeral.',
    amount_applied_required: 'Fa’amolemole tuu i totonu le aofa’i e te mana’o e nōnō.',
    amount_applied_maxvalue: 'E lē tatau ona sili atu ma le {0} {2} le aofa’i e faatalosagaina.',
    amount_applied_minvalue: 'E tatau ona pe tusa ma le {0} {1} tala le aofai’ga o le tupe e talosagaina.',

    tenure_required: 'Fa’amolemole tuu i totonu le taimi fuafuaina mo le totogiina o loo e apalai iai.',
    tenure_maxvalue: 'O le umi fuafuaina mo le totogiina e tatau ona le sili atu ma le {1} masina.',
    tenure_minvalue: 'O le taimi maualalo fuafuaina mo le totogiina e tatau ona pe tusa ma le {0} masina.',
    tenure_numeric: 'The only acceptable characters are numeral.',
    greaterThan12: 'The maximum financing tenure must not exceed 12 months..',
    lessThan3: 'The minimum financing tenure must be at least 3 months.',

    officerinchargeid_required: 'Fa’amolemole tuu i totonu le numera o le ID a le Tagata Ofisa mo Nōnōgatupe o loo faia lau mataupu.',
    officerinchargeid_invalid: 'Invalid Loan Officer ID. Please enter the correct Loan Officer ID.',
    officerinchargeid_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    officerinchargeid_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o numera o le ID.',
    officerinchargeid_max: 'E le tatau ona sili atu ma le 15 mata’itusi o le numera o le ID.',

    username_required: 'Fa’amolemole tuu i totonu le igoa.',
    username_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o lau igoa.',
    username_max: 'E le tatau ona 15 mata’itusi le umi o lau igoa.',
    username_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    username_duplicate: 'Ua fa’aaoga le igoa lena. Fa’amolemole tuu i totonu se isi igoa.',

    password_required: 'Fa’amolemole tuu i totonu le password.',
    password_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o lau password.',
    password_max: 'E le tatau ona sili atu ma le 15 mata’itusi numera o lau password.',
    password_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    confirm_password_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    new_password_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',

    confirm_password_required: 'Toe tuu i totonu lau password mo le fa’amautinoaina.',
    confirm_password_confirmed: 'E le o tutusa lau password ma le password fa’amautinoa.',
    confirm_password_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o lau password.',
    confirm_password_max: 'E le tatau ona sili atu ma le 15 mata’itusi numera o lau password.',

    registrationtoken_required: 'Fa\'amolemole ta i totonu le code fa\'amaonia ua tu\'uina atu ia te oe.',
    registrationtoken_min: 'E tatau ona 6 mata’itusi le umi o lau code fa\'amaonia.',
    registrationtoken_max: 'E tatau ona 6 mata’itusi le umi o lau code fa\'amaonia.',
    registrationtoken_duplicate: 'E le’o sa’o le code fa\'amaonia. Fa\'amolemole ta i totonu le code sa\'o.',
    registrationtoken_regex: 'O mata’itusi e taliaina na\'o mata’itusi o le alafapeta ma numera.',
    registrationtoken_invalid: 'E le’o sa’o le code fa\'amaonia. Fa\'amolemole ta i totonu le code sa\'o.',

    confirm_password_placeholder: 'Toe tuu i totonu lau password.',

    error: 'E le sa’o le igoa poo le password.',
    registration_error: 'SSa i ai se fa\'afitauli, fa\'amolemole toe taumafai.',
    new_password_required: 'Fa’amolemole tuu i totonu lau password fou.',
    confirm_new_password_required: 'Fa’amolemole toe tuu  i totonu lau password mo le fa’amautinoaina.',
    invalid_credentials: 'E le’o sa’o le code fa\'amaonia, Fa\'amolemole resitala e tatala ai.',
    verification_code_0: 'Code fa\'amaonia e le sa\'o. Fa\'amolemole ulufale le code sa\'o',

    consent_required: 'A\'o le\'i mafai ona resitalaina oe, e tatau ona e faitau i le Maliēga mo Puipuiga o Fa\'amaumauga Patino ma talia e ala i le makaina o le pusa ua tu\'uina atu.',

    reset_invalid: 'We are unable to find your account by the details provided.',
    new_password_min: 'Your password must be at least 6 characters long.',
    new_password_max: 'Your password cannot be longer than 15 characters.',
    confirm_new_password_min: 'Your password must be at least 6 characters long.',
    confirm_new_password_max: 'Your password cannot be longer than 15 characters.',
    confirm_new_password_confirmed: 'Your password and confirmed passwords do not match.',
    register_username_details_does_not_match: ' Your identification number does not match the registration record.',
    register_username_not_found: 'Forgot your username? Please contact support.',
    data_tempered: 'Unable to reset your password. Please try again later.',
    branch_required: 'Please select the Branch.',
    drop_down_not_available: 'No data available',
    repeating_user: 'Sorry, your registration cannot be processed.',
    incompleteAssessment: 'Sorry, your registration cannot be processed. User available with incomplete assessment',
    invalid_amount: 'Sorry, your registration cannot be processed. Invalid Financing Amount',
    invalid_tenure: 'Sorry, your registration cannot be processed. Invalid Financing Tenure',

    id_type_required: 'Fa’amolemole filifili le ituaiga o pepa fa’amaonia mo lou ID.',
    br_type_required: 'Please select Business Registration type.',

    customer_id_required: 'Please enter your customer ID.',
    customer_id_min: 'The ID number must be at least 3 characters long.',
    customer_id_max: 'The ID number must not be longer than 20 characters.',
    customer_id_regex: 'O mata’itusi e taliaina na\'o mata’itusi o le alafapeta ma numera.',

    application_number_required: 'Please enter your application number.',
    application_number_min: 'The application number must be at least 3 characters long.',
    application_number_max: 'The application number must not be longer than 10 characters.',
    application_number_regex: 'O mata’itusi e taliaina na\'o mata’itusi o le alafapeta ma numera.',

    verification_code_required: 'Fa\'amolemole ta i totonu le code fa\'amaonia na fa\'aaoga i le taimi o le resitala.',
    verification_code_min: 'E tatau ona 6 mata’itusi le umi o lau code fa\'amaonia.',
    verification_code_max: 'E tatau ona 6 mata’itusi le umi o lau code fa\'amaonia.',
    verification_code_duplicate: 'E le’o sa’o le code fa\'amaonia. Fa\'amolemole ta i totonu le code na fa\'aaoga i le taimi o le resitala.',
    verification_code_regex: 'O mata’itusi e taliaina na\'o mata’itusi o le alafapeta ma numera.'

  },
  registration: {
    full_name: 'Full Name (as per your ID)',
    first_name: 'Igoa Muamua',
    last_name: 'Fa\'ai\'u',

    id_num: 'Identification Number (ID)',
    business_reg: 'Business Registration/Business License No.',
    company_name: 'Company Name',
    product_applied: 'Ituaiga Fa\'atupega*',
    commencement_date: 'Business Commencement Date',
    facilities: 'Facilities Applied',
    amount_applied: 'Financing Amount Requested ($)',
    tenure: 'Financing Tenure (in months)',
    business_category: 'Business Category',
    confirm_password: 'Confirm Password',
    verification_code: 'Code Fa\'amaonia',
    consent1: 'Ua ou faitau ma malamalama i le Maliēga mo',
    consent2: 'Puipuiga o Fa\'amaumauga Patino',
    consent3: 'ma ua ou  malie i le fa\'aogaina o o\'u fa\'amaumauga patino e pei ona fa\'amatalaina i lea Maliēga',
    cancel: 'FA\'ALĒAOGĀ',
    register: 'RESITALA',
    branch: 'Branch',
    officer: 'Loan Officer ID No.',
    id_type: 'ID Document Type',
    br_type: 'Business Registration Number Type',
    customer_id: 'Customer ID',
    application_number: 'Application Number'
  }
}
